module.exports = __webpack_public_path__ + "static/media/m15cr0.a71a5e79.png";